import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '../common/table';
import { useGetBankAccounts } from '../../api/hooks/sales';

export default function BankAccountTable() {
  const { data: accounts } = useGetBankAccounts();
  return (
    <Paper variant="outlined" sx={{ width: '100%' }}>
      <Table columns={columns} rows={accounts} />
    </Paper>
  );
}

const columns = [
  { id: 'bank', label: 'بانک', minWidth: 50 },
  {
    id: 'accountNumber',
    label: 'حساب',
    minWidth: 70,
    format: (accountNumber) => accountNumber.substring(accountNumber.length - 5),
  },
  {
    id: 'shebaNumber',
    label: 'شبا',
    minWidth: 70,
    format: (sheba) => sheba.substring(sheba.length - 5),
  },
  { id: 'owner', label: 'صاحب', minWidth: 70, format: (owner) => owner.name },
];
